// extracted by mini-css-extract-plugin
export default {"NoReposContainer":"NoReposContainer_NoReposContainer__4kzl6","NoReposIcon":"NoReposContainer_NoReposIcon__nrkcD","NoReposText":"NoReposContainer_NoReposText__BEmCs"};